import React from 'react';
import Breadcrumb from '../components/common/Breadcrumb';

const SizeChartPage = () => {
  return (
    <div className="bg-white min-h-screen py-8">
      <div className="container mx-auto px-4 md:px-8">
        <div className="border-b pb-4 mb-8">
          <Breadcrumb items={[{ label: 'Home', path: '/' }, { label: 'Size Chart', path: '/size-chart' }]} />
        </div>

        <h1 className="text-3xl font-light text-center text-gray-900 mb-10 tracking-wide">SIZE CHART</h1>

        <div className="mb-12">
          <h2 className="text-xl font-medium text-center mb-6 text-gray-800">WOMEN'S SHOES SIZE CHART</h2>
          <div className="overflow-x-auto">
            <table className="w-full border border-gray-200 text-xs md:text-sm">
              <thead style={{ backgroundColor: 'var(--primary-color)', color: 'white' }}>
                <tr>
                  <th className="p-3 text-center border-r border-white/20">EUROPE</th>
                  <th className="p-3 text-center border-r border-white/20">UK</th>
                  <th className="p-3 text-center border-r border-white/20">US</th>
                  <th className="p-3 text-center border-r border-white/20">INCHES</th>
                  <th className="p-3 text-center">CM</th>
                </tr>
              </thead>
              <tbody className="text-center text-gray-700">
                <tr className="border-b border-gray-200"><td className="p-3">35</td><td className="p-3">3</td><td className="p-3">5.5</td><td className="p-3">22.5</td><td className="p-3">22.86</td></tr>
                <tr className="border-b border-gray-200"><td className="p-3">36</td><td className="p-3">3.5</td><td className="p-3">6</td><td className="p-3">23</td><td className="p-3">23.3</td></tr>
                <tr className="border-b border-gray-200"><td className="p-3">37</td><td className="p-3">4</td><td className="p-3">6.5</td><td className="p-3">23.5</td><td className="p-3">23.81</td></tr>
                <tr className="border-b border-gray-200"><td className="p-3">38</td><td className="p-3">4.5</td><td className="p-3">7</td><td className="p-3">24</td><td className="p-3">24.13</td></tr>
                <tr className="border-b border-gray-200"><td className="p-3">39</td><td className="p-3">5</td><td className="p-3">7.5</td><td className="p-3">24.5</td><td className="p-3">24.77</td></tr>
                <tr className="border-b border-gray-200"><td className="p-3">40</td><td className="p-3">6</td><td className="p-3">8.5</td><td className="p-3">25.5</td><td className="p-3">25.4</td></tr>
                <tr className="border-b border-gray-200"><td className="p-3">41</td><td className="p-3">6.5</td><td className="p-3">9</td><td className="p-3">26</td><td className="p-3">25.9</td></tr>
                <tr className="border-b border-gray-200"><td className="p-3">42</td><td className="p-3">7</td><td className="p-3">9.5</td><td className="p-3">26.5</td><td className="p-3">26.3</td></tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="mb-12">
          <h2 className="text-xl font-medium text-center mb-6 text-gray-800">KID'S SIZE CHART</h2>
          <div className="overflow-x-auto">
            <table className="w-full border border-gray-200 text-xs md:text-sm">
              <thead style={{ backgroundColor: 'var(--primary-color)', color: 'white' }}>
                <tr>
                  <th className="p-3 text-center border-r border-white/20">AGE</th>
                  <th className="p-3 text-center border-r border-white/20">HEIGHT (CM)</th>
                  <th className="p-3 text-center">WAIST (INCHES)</th>
                </tr>
              </thead>
              <tbody className="text-center text-gray-700">
                <tr className="border-b border-gray-200"><td className="p-3">0-3 Months</td><td className="p-3">53-58</td><td className="p-3">15.7</td></tr>
                <tr className="border-b border-gray-200"><td className="p-3">3-6 Months</td><td className="p-3">58-63</td><td className="p-3">17.3</td></tr>
                <tr className="border-b border-gray-200"><td className="p-3">6-9 Months</td><td className="p-3">63-68</td><td className="p-3">18.9</td></tr>
                <tr className="border-b border-gray-200"><td className="p-3">9-12 Months</td><td className="p-3">68-73</td><td className="p-3">20.5</td></tr>
                <tr className="border-b border-gray-200"><td className="p-3">12-18 Months</td><td className="p-3">73-78</td><td className="p-3">22.0</td></tr>
                <tr className="border-b border-gray-200"><td className="p-3">1 Year</td><td className="p-3">73-78</td><td className="p-3">22.0</td></tr>
                <tr className="border-b border-gray-200"><td className="p-3">2 Years</td><td className="p-3">78-83</td><td className="p-3">23.0</td></tr>
                <tr className="border-b border-gray-200"><td className="p-3">3 Years</td><td className="p-3">83-88</td><td className="p-3">24.0</td></tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="mb-12">
          <h2 className="text-xl font-medium text-center mb-6 text-gray-800">WOMEN'S DENIM SIZE CHART</h2>
          <div className="overflow-x-auto">
            <table className="w-full border border-gray-200 text-xs md:text-sm">
              <thead style={{ backgroundColor: 'var(--primary-color)', color: 'white' }}>
                <tr>
                  <th className="p-3 text-center border-r border-white/20">SIZE</th>
                  <th className="p-3 text-center border-r border-white/20">WAIST (IN)</th>
                  <th className="p-3 text-center border-r border-white/20">HIP (IN)</th>
                  <th className="p-3 text-center border-r border-white/20">INSEAM (IN)</th>
                  <th className="p-3 text-center">BOTTOM OPENING (IN)</th>
                </tr>
              </thead>
              <tbody className="text-center text-gray-700">
                <tr className="border-b border-gray-200"><td className="p-3">24</td><td className="p-3">24</td><td className="p-3">34.5</td><td className="p-3">30</td><td className="p-3">11.5</td></tr>
                <tr className="border-b border-gray-200"><td className="p-3">26</td><td className="p-3">26</td><td className="p-3">36.5</td><td className="p-3">30</td><td className="p-3">12</td></tr>
                <tr className="border-b border-gray-200"><td className="p-3">27</td><td className="p-3">27</td><td className="p-3">37.5</td><td className="p-3">30</td><td className="p-3">12.5</td></tr>
                <tr className="border-b border-gray-200"><td className="p-3">28</td><td className="p-3">28</td><td className="p-3">38.5</td><td className="p-3">30</td><td className="p-3">13</td></tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="mb-12">
          <h2 className="text-xl font-medium text-center mb-6 text-gray-800">1PCS EMBELLISHED SIZE CHART</h2>
          <div className="overflow-x-auto">
            <table className="w-full border border-gray-200 text-xs md:text-sm">
              <thead style={{ backgroundColor: 'var(--primary-color)', color: 'white' }}>
                <tr>
                  <th className="p-3 text-center border-r border-white/20">DETAILS</th>
                  <th className="p-3 text-center border-r border-white/20">XS</th>
                  <th className="p-3 text-center border-r border-white/20">S</th>
                  <th className="p-3 text-center border-r border-white/20">M</th>
                  <th className="p-3 text-center border-r border-white/20">L</th>
                  <th className="p-3 text-center">XL</th>
                </tr>
              </thead>
              <tbody className="text-center text-gray-700">
                <tr className="border-b border-gray-200"><td className="p-3 font-semibold">BUST</td><td className="p-3">18</td><td className="p-3">19</td><td className="p-3">20</td><td className="p-3">21</td><td className="p-3">22</td></tr>
                <tr className="border-b border-gray-200"><td className="p-3 font-semibold">SHOULDER</td><td className="p-3">13.5</td><td className="p-3">14</td><td className="p-3">14.5</td><td className="p-3">15</td><td className="p-3">15.5</td></tr>
                <tr className="border-b border-gray-200"><td className="p-3 font-semibold">ARMHOLE</td><td className="p-3">8.25</td><td className="p-3">8.75</td><td className="p-3">9.5</td><td className="p-3">10</td><td className="p-3">10.5</td></tr>
                <tr className="border-b border-gray-200"><td className="p-3 font-semibold">WAIST</td><td className="p-3">18</td><td className="p-3">19</td><td className="p-3">20</td><td className="p-3">21</td><td className="p-3">22</td></tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
  );
};

export default SizeChartPage;